'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTitleFlags = undefined;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _ = require('../');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var getTitleFlags = exports.getTitleFlags = function getTitleFlags(_ref) {
  var customAttributes = _ref.customAttributes,
    dataflowAttributes = _ref.dataflowAttributes,
    display = _ref.display;
  var _display = (0, _.parseDisplay)(display);
  var formatter = (0, _.dimensionValueDisplay)(_display);
  return (0, _.getFlags)(customAttributes, formatter, {})({
    attributes: dataflowAttributes
  });
};